import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

// Grommet

// Appt
import Box from '../components/simple/box/Box.js'
import Login from '../components/compound/login/Login.js'
import PasswordResetRequest from '../components/compound/login/PasswordResetRequest.js'
import Text from '../components/simple/text/Text.js'
import UserVerification from '../components/compound/login/UserVerification.js'
import Image from '../components/simple/image/Image.js'


// Services
import ApiService from '../services/ApiService'
import NotificationService from '../services/NotificationService'
import PasswordService from '../services/PasswordService'
import LocalStorageService from '../services/LocalStorageService.js'
import SSOService from '../services/SSOService.js'

// Stores
import { useStore } from 'react-context-hook'

// Error handler
// import useErrorHandler from '../utils/useErrorHandler'

// Theme
// import { hostTheme } from 'utilities/hostTheme'
import ActionButton from '../components/compound/actionButton/ActionButton.js'

import { CONNECTION_DEBUG, FEATURE_SSO_ENABLED, SECURITY_ENFORCE_PASSWORD_POLICY } from "../env";
import TextInput from '../components/simple/input/TextInput.js'

function LoginScreen(props) {
  const navigate = useNavigate()

  const [loading, setLoading] = useState(false)
  const [loginInProgress, setLoginInProgress] = useState(false)
  const [createPassword, setCreatePassword] = useState(false)
  const [viewLogin, setLoginView] = useState(true)
  const [verificationNeeded, setVerification] = useState(false)
  const [userValues, setUserValues] = useState()

  const [error, setError] = useState(null)

  
  const [devLogin, setDevLogin] = useState('jon.bollinger@teamteach.com')
  const [devGuid, setDevGuid] = useState('3fa85f64-5717-4562-b3fc-2c963f66afa6')
  const [devSSOStatus, setDevSSOStatus] = useState(null)
  const [devSSOToken, setDevSSOToken] = useState(null)


  const myLogin = () => {
      SSOService.getLoginURL()
    }

  // const { error, showError } = useErrorHandler(null)

  const startListener = () => {
    window.addEventListener('message', handleMessage);
  }

  const handleMessage = (event) => {
    if (event.origin !== ApiService._getServerRoot()) return;

    let status = event.data?.status || null;
    let sessionToken = event.data?.sessionToken || null;

    if (status !== 'SSO_SUCCESS' || !sessionToken) {
      NotificationService.error('SSO login failed. Please try again.')
    }

    if (status === 'SSO_SUCCESS' && sessionToken) {
      SSOService.setSSOSessionToken(sessionToken)
      setDevSSOToken(sessionToken)

      getProfile(sessionToken) 
    }

    setDevSSOStatus(status)
    setLoginInProgress(false)
    window.removeEventListener('message', handleMessage);
    

  }

  const getSSOSessionToken = async () => {
    let token = SSOService.getSSOSessionToken();
    return token;
  }

  useEffect(() => {
    getSSOSessionToken().then((token) => {
      if (token) {
        setDevSSOToken(token)
      }
    })
  }, [])

  const getProfile = async (sessionToken) => {

    if (process.env.FEATURE_SSO_ENABLED !== "true") {
      return;
    }

    if (!sessionToken) return;
    try {
      const profile = await SSOService.getProfile(sessionToken);

      if (profile.status === 'error') {
        console.error('Error retrieving profile:', profile.message);
        NotificationService.error('Unable to establish a session, please try again.')
        return
      }

      if (profile.status === 'loggedin') {
        props.handleLogin(profile.loginData)
          // if you're here, you're logged in
        navigate('/dashboard')
        return
      }

      if (profile.status === 'onboarding') {
        navigate('/get-started')
        return
      }

    } catch (err) {
      console.error('Failed to get profile:', err);
      NotificationService.error('Failed to retrieve profile. Please try again.')
    }
  }

  const doLogin = async () => {
  }


  const clearLoginState = () => {
    setLoginInProgress(false)
    setDevSSOStatus(null)
    setDevSSOToken(null)
    SSOService.clearSSOSessionToken()
  }

  const startLogin = () => {
    clearLoginState();
    setLoginInProgress(true)
    startListener()
    window.open(SSOService.getLoginURL() + `?devEmail=${encodeURIComponent(devLogin)}&devGuid=${devGuid}`, 'loginWindow', 'width=400,height=600')
  }

  const startConnectLogin = () => {
    clearLoginState();
    setLoginInProgress(true)
    startListener()
    window.open(SSOService.getConnectLoginURL() + `?devEmail=${encodeURIComponent(devLogin)}&devGuid=${devGuid}`, 'loginWindow', 'width=400,height=600')
  }

  const signup = () => {
    window.open('https://www.behavioursmart.co.uk/new-signup-page', '_blank')
  }


  const resetPasswordClicked = async (values) => {
    // organisationId not needed for a reset password from the login screen
    const organisationId = 50
    try {
      var passwordResetStatus = await PasswordService.resetPasswordRequest(organisationId, values.email)
    } catch (err) {
      NotificationService.error(err)
    }

    NotificationService.info('A password reset has been requested. Please check your inbox.')
    setLoginView(true)
  }

  if (FEATURE_SSO_ENABLED !== "true") {
    return (
      <Box align='center' height='100%' justify='center' alignSelf='center'>
        <Text color='white' weight='bold' size='medium'>SSO is currently disabled.</Text>
      </Box>
    )
  }

  return (
    <>
      <Box align='center' height='100%' justify='center' alignSelf='center'>
        <Box width='small' alignSelf='center' height='xsmall' margin={{ bottom: 'medium' }}>
          <Image fit='contain' src='/besmart-logo-white.png?r=001' />
        </Box>
        {CONNECTION_DEBUG === 'true' && <>
          <Text color='white'>Server: {ApiService._getServerRoot()}</Text>
        </>}

        <Box border={{ color: 'brand', side: 'top' }}>
          {viewLogin && !verificationNeeded &&
            <>
              <Box pad={{ vertical: 'medium' }} width='medium'>
                {error?.length > 0 && <Box width='medium' height='xsmall' align='center' margin={{ bottom: 'small' }} pad='small' background='primary' round='small'>
                  <Text color='secondary' size='medium' weight='bold'>{error}</Text>
                </Box>}
                <Text color='white' weight='bold' size='medium'>[DEV BYPASS] Email to authenticate with</Text>
                <TextInput
                  value={devLogin}
                  onChange={e => setDevLogin(e.target.value)}
                  placeholder="Enter DEV login"
                />

                <ActionButton
                  label={loginInProgress ? 'Logging in...' : 'Login to continue'}
                  primary
                  margin={{ bottom: 'small' }}
                  onClick={startLogin}
                />

              <Text color='white' weight='bold' size='medium'>Cognito</Text>
              <ActionButton
                  label={loginInProgress ? 'Connecting...' : 'Login with TT Connect'}
                  primary
                  margin={{ bottom: 'small' }}
                  onClick={startConnectLogin}
                />



                {/* <Text color='white' weight='bold' size='medium'>[DEV] SSO Status: {devSSOStatus || 'n/a'}</Text> */}
                {/* <Text color='white' weight='bold' size='medium'>[DEV] SSO Token: {devSSOToken || 'n/a'}</Text> */}

  

                <Box
                  margin={{ top: 'small', bottom: 'medium' }}
                  align='center'
                  onClick={() => myLogin()}
                >
                  <Image
                    size="medium"
                    color="brand"
                    width='60%'
                    src={'/myLoginLogo.png?r=001'}
                  />
                </Box>
              </Box>


              <Box width='medium' align='center' border={{ color: 'brand', side: 'top' }} pad={{ top: 'small' }}>
                <Text color='white' weight='bold' size='medium'>Don't have an account?</Text>
                <ActionButton onClick={() => signup()} secondary><Text color='primary' weight='bold' size='medium' margin={{ bottom: 'xsmall' }}>Sign up for Behaviour Smart here.</Text></ActionButton>
              </Box>
            </>
          }
          {!viewLogin && !verificationNeeded &&
            <Box fill justify='center' pad={{ vertical: 'medium' }} border={{ color: 'brand', side: 'bottom' }}>
              <PasswordResetRequest labelColor='#ffffff' onBackClick={viewLoginScreen} onResetPasswordClick={resetPasswordClicked} />
            </Box>}
          { verificationNeeded &&
            <Box fill justify='center' pad={{ vertical: 'medium' }} border={{ color: 'brand', side: 'bottom' }}>
              <UserVerification labelColor='#ffffff' onBackClick={viewLoginScreen} handleVerificationCode={handleVerificationCode} />
            </Box>}
        </Box>
      </Box>

    </>
  )
}

export default LoginScreen
